import { css } from '@emotion/css';
import { Dimensions20, Spacings1 } from '@efexteam/design-tokens';

const wrapper = css({
  display: 'inline-flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: Spacings1,
  width: '100%',
  maxWidth: '148px',
});

const mainLogo = css({
  maxWidth: '120px',
  maxHeight: '55px',
  width: '100%',
  height: 'auto',
  objectFit: 'contain',
});

const poweredBy = css({
  maxWidth: Dimensions20,
  width: '100%',
  height: 'auto',
  objectFit: 'contain',
  opacity: 0.8,
});

const LogoControllerStyles = {
  wrapper,
  mainLogo,
  poweredBy,
};

export default LogoControllerStyles;
